import { authenticatedApi } from "../api";
import { MICROSERVICE_CONFIG } from "../../config/configs";

export const getMenuItems_api = async ({ id, params }) => {
	if (id) {
		const response = await authenticatedApi.get(
			`${MICROSERVICE_CONFIG.RESTAURANT}/restaurants/${id}/menu/items?${params}`
		);
		return response.data;
	}
};
